export default "__VITE_ASSET__pszMF5FH__"